import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Plus, Minus } from '../../assets/images';

const CountAdjusterButton = ({ onClick, type }) => {
    const theme = useTheme();

    return (
        <IconButton
            size="small"
            onClick={onClick}
            sx={{
                width: '24px',
                height: '24px',
                '&:hover': {
                    backgroundColor: theme.palette.figma.white[30]
                }
            }}
        >
            {type === 'plus' ? <Plus size={16} /> : <Minus size={16} />}
        </IconButton>
    );
};

const CountAdjuster = ({ grade, count, onAdjust }) => {
    const theme = useTheme();

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            gap: 1
        }}>
            <CountAdjusterButton type="minus"
                onClick={() => onAdjust(grade, -1)}
            />
            <Typography sx={{
                minWidth: '30px',
                textAlign: 'center',
                color: theme.palette.text?.primary
            }}>
                {count}
            </Typography>
            <CountAdjusterButton type="plus"
                onClick={() => onAdjust(grade, 1)}
            />
        </Box>
    );
};

export default CountAdjuster;

